import i18n from "../i18n";

/**
* 参数处理
* @param {*} params  参数
*/
export function tansParams(params) {
	let result = ''
	for (const propName of Object.keys(params)) {
		const value = params[propName];
		var part = encodeURIComponent(propName) + "=";
		if (value !== null && typeof (value) !== "undefined") {
			if (typeof value === 'object') {
				for (const key of Object.keys(value)) {
					if (value[key] !== null && typeof (value[key]) !== 'undefined') {
						let params = propName + '[' + key + ']';
						var subPart = encodeURIComponent(params) + "=";
						result += subPart + encodeURIComponent(value[key]) + "&";
					}
				}
			} else {
				result += part + encodeURIComponent(value) + "&";
			}
		}
	}
	return result
}



/**
 * 构造路由树型结构数据
 * @param {*} list 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 */
export function handleTree(list, id, parentId, children) {
	list.unshift({
		parentName: '',
		parentId: 0,
		typeId: 1,
		url: '/HomePage',
		// component:`@/view${it.url}.vue`,
		path: '/',
		name: 'HomePage',
		typeName: i18n.t('home.homePage'),
	})
	let data = list.map(it => {
		// console.log(it.url);
		if (it.url) {
			let dl = {
				parentName: it.parentName,
				parentId: it.parentId,
				typeId: it.typeId,
				component: () => import(`@/view${it.url}.vue`),
				// component:`@/view${it.url}.vue`,
				path: it.path,
				name: it.name,
				meta: {
					title: it.typeName,
					typeId:it.typeId,
				},
			}
			return dl
		} else {
			let dl = {
				parentName: it.parentName,
				parentId: it.parentId,
				typeId: it.typeId,
				component: '',
				// component:`@/view${it.url}.vue`,
				path: it.path,
				name: it.name,
				meta: {
					title: it.typeName
				},
			}
			return dl
		}
	})
	let config = {
		id: id || 'id',
		parentId: parentId || 'parentId',
		childrenList: children || 'children'
	};

	var childrenListMap = {};
	var nodeIds = {};
	var tree = [];

	for (let d of data) {
		let parentId = d[config.parentId];
		if (childrenListMap[parentId] == null) {
			childrenListMap[parentId] = [];
		}
		nodeIds[d[config.id]] = d;
		childrenListMap[parentId].push(d);
	}

	for (let d of data) {
		let parentId = d[config.parentId];
		if (nodeIds[parentId] == null) {
			tree.push(d);
		}
	}

	for (let t of tree) {
		adaptToChildrenList(t);
	}

	function adaptToChildrenList(o) {
		if (childrenListMap[o[config.id]] !== null) {
			o[config.childrenList] = childrenListMap[o[config.id]];
		}
		if (o[config.childrenList]) {
			for (let c of o[config.childrenList]) {
				adaptToChildrenList(c);
			}
		}
	}
  // tree.push(   {
  //   path: '/newsDetail',
  //   name: 'newsDetail',
  //   component: resolve => require(['@/view/NewsDetail'], resolve),
  // })
  //
	return tree;
}



// WEBPACK FOOTER //
// ./src/router/format.js